import React from "react";

import Layout from "../components/excursionesLayout";

const Page = () => <Layout />;

export default Page;
